import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Table } from 'primeng/table';
import {
  FormBuilder,
  FormControl,
  FormControlDirective,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { invalid } from "moment";
import { ConfirmationService } from "primeng/api";
import { Message } from "primeng/api";
import { PrimeNGConfig } from "primeng/api";
import { ApiServiceService } from "src/app/api-service.service";
import { AppUtility } from "src/app/interceptor/appUtitlity";
import { CheckboxModule } from "primeng/checkbox";
@Component({
  selector: "app-loan-tool-agreement",
  templateUrl: "./loan-tool-agreement.component.html",
  styleUrls: ["./loan-tool-agreement.component.scss"],
})
export class LoanToolAgreementComponent implements OnInit {
  @ViewChild("dataToExport", { static: false }) public dataToExport: ElementRef;
  @ViewChild("fileBrowse") fileBrowse: ElementRef;
  @ViewChild("faaDocument") faaDocumentview: ElementRef;
  @ViewChild('dt2') FilteredData: Table;
  @ViewChild('dtAssetList') FilteredData2: Table;
  @ViewChild('form') form: NgForm;
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('Carupload') Carupload: ElementRef
  msgs: Message[] = [];
  displayToolLoan: boolean = false;
  showToolHealth: boolean = false;
  header: string = "Document Details";
  rfqToolTotal: number = 0;
  checkId: any;
  toolId: number;
  toolmasterid: number
  sendToolId: any;
  check1Id: any[] = [];
  supplierNameArray: any[] = [];
  // check1Id:any;
  itemId: any;
  ToolListData: any[] = [];
  check1CommaSeparatedValues: any;
  uploadedFiles: { file: File, toolLoanDetailId: string }[] = [];
  role: any;
  financeData: any[] = []
  toolListChecked: any[] = [];
  selectedAssets: any[] = [];
  display: boolean = false;
  sendToSupplierId: any;
  approveModalState: boolean = false;
  packagewisedetail: boolean = false
  agreementdetail: boolean = false
  isApprove: boolean = false
  isReject: boolean = false
  toggleValue: boolean = false
  checker2ModalState: boolean = false
  toollistStringId: string
  statusString: any;
  filterval: string;
  filterval2: string;
  packagedata: any[] = [];
  editpackagedata: any[] = []
  packagedatabyid: any[] = [];
  supplierdata: any[] = [];
  selectedItems: any[] = [];
  alldata: any[] = [];
  checker2assign: boolean = false
  existingCarUploadUrl: any
  checker2list: any[] = []
  selectedChecker2Id: any
  isChecker1: boolean = false;
  isChecker2: boolean = false;
  isChecker3: boolean = false;
  checker3ModalState: boolean = false;
  checker3assign: boolean = false;
  checker3list: any[] = [];
  selectedChecker3Id: any;
  newsupplierid: any
  constructor(
    private route: Router,
    public _apiService: ApiServiceService,
    private confirmationService: ConfirmationService,
    private primengConfig: PrimeNGConfig,
    public _utility: AppUtility,
    private fb: FormBuilder
  ) { }
  supplierOrders: any = [];

  ngOnInit(): void {
    this.primengConfig.ripple = true;
    // this.showToolHealth = this.route.url == '/toolhealthCheck' ? true : false;
    this.supplierId = this._utility.getLocalStorageDetails();
    this.getAssignQuotation();
    this.getToolListData();
    // this.loadDataFromAPI()
    this.role = JSON.parse(localStorage.getItem("UserObject"));
    console.log("role", this.role);
    this.isChecker1 = this.role.checker1 == true;
    this.isChecker2 = this.role.checker2 == true && this.role.roleName === 'Bussiness head';
    this.isChecker3 = this.role.checker3 == true && this.role.roleName === 'User';
  }

  breadcrumb = [
    {
      title: "Tool Loan Details",
      subTitle: "Dashboard",
    },
  ];

  loginName: string = "";
  roleName: string = "";
  disableRemark: boolean = false;
  supplierId: any = {};
  supplierEnquiryData: any = [];
  toolData: any = [];
  allData: any = [];
  getAssignQuotation() {
    let roleName = this._utility.getLocalStorageDetails();
    this.disableRemark = roleName.roleName == "Supplier" ? true : false;
    this.roleName = roleName.roleName;
    this.loginName = roleName.loginName;
    let object = {};
    if (roleName.roleName == "Supplier") {
      object = {
        supplierId: this.supplierId?.supplierId,
        roleName: this.roleName,
        loginId: roleName.loginId,
      };

      this._apiService
        .getToolLoanAgreementDataByItemId(object)
        .then((res: any) => {
          if (res.success == true) {
            if (res.success) {
              this.supplierEnquiryData = res.returnValue;
            } else {
              this.supplierEnquiryData = [];
            }
          } else {
            this.supplierEnquiryData = [];
          }
        });
    } else if (roleName.roleName != "Supplier") {
      object = {
        loginId: roleName.loginId,
        roleName: this.roleName,
        supplierId: 0,
      };
      this._apiService
        .dropdowndata("ToolLoanAgreementList")
        .then((res: any) => {
          if (res.success == true) {
            if (res.success) {
              this.supplierEnquiryData = res.returnValue;
            } else {
              this.supplierEnquiryData = [];
            }
          } else {
            this.supplierEnquiryData = [];
          }
        });
    }
  }
  // loadDataFromAPI() {
  //   const mockResponse = {
  //     ApprovedRemark: 'Tool verified and approved',
  //     Carno: 'MH12AB1234',
  //     Carupload: 'https://example.com/uploads/car-document.jpg', // You can change this to pdf, xlsx, etc.
  //   };

  //   this.approvalForm.patchValue({
  //     ApprovedRemark: mockResponse.ApprovedRemark,
  //     Carno: mockResponse.Carno,
  //     // Carupload is usually handled differently
  //   });


  //     this.approvalForm.get('ApprovedRemark')?.disable();
  //     this.approvalForm.get('Carno')?.disable();
  //     this.approvalForm.get('Carupload')?.disable(); // Optional
  // }

  sendMail(customer) {
    this._utility.loader(true);
    console.log(customer);
    let object = {
      enquiryId: customer.enquiryId,
      itemId: customer.itemId,
      supplierId: customer.supplierId,
    };

    this._apiService.postToolLoanAgreementDocument(object).then((res: any) => {
      console.log(res);
      this._utility.loader(false);
      if (res.success) {
        this._apiService.showMessage(res.message, "success");
        this.getAssignQuotation();
      } else {
        this._apiService.showMessage(res.message, "error");
      }
    });
  }

  enquiryId: any;
  // async getToolLoan(customer) {
  //     console.log(customer);
  //     this.itemId = customer.itemId;
  //     this.supplierId = {supplierId : customer.supplierId};
  //     this.enquiryId = customer.enquiryId;
  //     this._utility.loader(true);
  //     let object = {
  //         itemId: customer.itemId,
  //         supplierId: customer.supplierId,
  //         enquiryNo: customer.enquiryNo,
  //         roleName: this.roleName
  //     }

  //     this._apiService.getAssignedSupplierQuotationCostBreakup(object).then((res: any) => {
  //         this._utility.loader(false);
  //         if (res.success) {
  //             this.allData = res.returnValue;
  //             this.toolData = res.returnValue?.assignToolLoanAgreementDetails;
  //             this.toolData?.forEach((response:any)=>{
  //                 response.toolDocument = [];
  //                 this.rfqToolTotal = response.toolLoanAgreementAmount + this.rfqToolTotal;
  //             })
  //         }
  //         else {
  //             this.toolData = [];
  //         }
  //     })

  //     this.getItemDetails();
  //     this.getCurrency(customer);
  // }

  async getToolLoan(customer) {
    console.log(customer);
    this.itemId = customer.itemId;
    this.supplierId = { supplierId: customer.supplierId };
    this.enquiryId = customer.enquiryId;
    this._utility.loader(true);
    let object = {
      itemId: customer.itemId,
      supplierId: customer.supplierId,
      enquiryNo: customer.enquiryNo,
      roleName: this.roleName,
    };

    this._apiService
      .getAssignedSupplierQuotationCostBreakup(object)
      .then((res: any) => {
        this._utility.loader(false);
        if (res.success) {
          this.allData = res.returnValue;
          this.toolData = res.returnValue?.assignToolLoanAgreementDetails;
          this.toolData?.forEach((response: any) => {
            response.toolDocument = [];
            this.rfqToolTotal =
              response.toolLoanAgreementAmount + this.rfqToolTotal;
          });
        } else {
          this.toolData = [];
        }
      });

    this.getItemDetails();
    this.getCurrency(customer);
  }

  itemDetails: any = [];
  displayItem: boolean = false;
  getItemDetails() {
    this.itemDetails = [];
    this._utility.loader(true);
    this._apiService.getItemMasterById(this.itemId).then((res: any) => {
      console.log(res);
      this._utility.loader(false);
      if (res.success) {
        this.itemDetails.push(res.returnValue);
      } else {
        this.itemDetails = [];
      }
    });
  }

  partDetails: any = {};
  async getCurrency(itemDetail) {
    this.displayToolLoan = false;
    console.log(itemDetail);
    this._utility.loader(true);
    let data = {
      Mode: "EnquiryItemDetail",
      supplierId: itemDetail.supplierId,
      itemId: itemDetail.itemId,
      cond3: itemDetail.enquiryId,
    };
    await this._apiService.dropdowndata("", data).then((res: any) => {
      this._utility.loader(false);
      this.displayToolLoan = true;
      if (res.success) {
        this.partDetails = res.returnValue[0];
        console.log(this.partDetails.cond2);
      } else {
        this.partDetails = [];
      }
    });
  }

  submitFAAImages() {
    console.log(
      this.faaDocument,
      this.allData,
      this.toolDocument,
      this.faaDocument
    );
    // if(this.faaDocument){
    let formData = new FormData();
    formData.append("supplierId", this.supplierId.supplierId);
    formData.append("itemId", this.itemId);
    formData.append("enquiryId", this.enquiryId);

    if (this.signed_doc) {
      formData.append("signed_doc", this.signed_doc);
    }
    if (this.faaDocument) {
      formData.append("faDocument", this.faaDocument);
    }
    this._apiService.putToolLoanAgreementDocument(formData).then((res: any) => {
      if (res.success) {
        console.log(res);
        this._apiService.showMessage(res.message, "success");
      } else {
        this._apiService.showMessage(res.message, "error");
      }
    });
    // }
  }

  faaDocument: any;
  toolDocument: any = [];
  signed_doc: any;
  upload_doc(event: any, string: any, index?: any) {
    let file = this._utility.onFileChange(event);

    if (string == "faaDocument") {
      if (file != false) {
        this.faaDocument = file;
      } else {
        this.faaDocumentview.nativeElement.value = "";
      }
    } else if (string == "signed_doc") {
      if (file != false) {
        this.signed_doc = file;
      }
    } else if (string == "toolDoc") {
      this.toolData[index].toolDocument = [];
      if (file != false) {
        console.log(Object.keys(file).length);
        if (Object.keys(file).length == 1) {
          this.toolData[index]["toolDocument"].push(file);
        } else {
          Object.keys(file).forEach((res: any) => {
            this.toolData[index].toolDocument.push(file[res]);
          });
        }
      }
    }
    else if (string == 'car_upload') {
      console.log("called");

      if (file != false) {
        this.approvalForm.controls['Carupload'].setValue(file);
      }
      console.log(this.approvalForm.controls['Carupload']);

    }
    else if (string == 'checker_invoice') {
      console.log("called");
      console.log(this.packagedatabyid, "afterpaclage");
      const data = this.packagedatabyid
      const currentToolLoanDetailId = this.packagedatabyid[index]?.toolLoanDetailId; // adjust as per your structure
      console.log(currentToolLoanDetailId);
      if (file) {
        if (Array.isArray(file)) {
          file.forEach(f => {
            this.uploadedFiles.push({ file: f, toolLoanDetailId: currentToolLoanDetailId });
          });
        } else if (file instanceof File) {
          this.uploadedFiles.push({ file: file, toolLoanDetailId: currentToolLoanDetailId });
        } else {
          console.warn('Invalid file type:', file);
        }
      }
      console.log(this.uploadedFiles, "checkdata");


      console.log(this.uploadedFiles);
    }

  }

  getToolDoc(index: any) {
    console.log(this.toolData, index);
    let formData = new FormData();
    formData.append("enquiryId", this.toolData[index].enquiryId);
    formData.append("itemId", this.toolData[index].itemId);
    formData.append("supplierId", this.toolData[index].supplierId);
    formData.append(
      "assignToolLoanAgreementId",
      this.toolData[index].assignToolLoanAgreementId
    );
    this.toolData[index].toolDocument.forEach((res: any) => {
      formData.append("filePaths", res);
    });
    this._apiService.putToolDocument(formData).then((res: any) => {
      console.log(res);
    });
  }

  displayImages: boolean = false;
  toolImages: any = [];
  toolName: string = "";
  getImages(images: any) {
    this._utility.loader(true);
    console.log(images);
    this.toolName = images.toolLoanAgreementName;
    let object = {
      mode: "ToolLoanAgreementDTL",
      cond3: images.assignToolLoanAgreementId,
    };
    console.log(object);
    this._apiService.dropdowndata("", object).then((res: any) => {
      console.log(res);
      this._utility.loader(false);
      if (res.success) {
        this.displayImages = true;
        this.toolImages = res.returnValue;
      } else {
        this.toolImages = [];
        this._apiService.showMessage(res.message, "error");
      }
    });
  }

  //   getSupplierOrders(){
  //     this._utility.loader(true);
  //     let supplierId = JSON.parse(localStorage.getItem('UserObject')).supplierId;

  //     let object = {
  //       supplierId : supplierId,
  //       supplier : 'supplier'
  //     }
  //     this._apiService.getSupplierOrders(object).then((res:any)=>{
  //       console.log(res);
  //       this._utility.loader(false);
  //       if(res.success == true){
  //         this.supplierOrders = res.returnValue;
  //       }
  //     })
  //   }

  //   orderItemList : any = [];
  //   onTabOpen(product:any){
  //     let supplierId = JSON.parse(localStorage.getItem('UserObject')).supplierId;    // api call
  //     console.log(product);
  //     let object = {
  //       enquiryId : this.supplierOrders[product.index].enquiryId,
  //       supplierId : supplierId,
  //       supplier : 'supplierbyId'
  //     }
  //     this._apiService.getSupplierOrders(object).then((res:any)=>{
  //       console.log(res);
  //       this.orderItemList = res.returnValue;
  //     })

  //     this.orderItemList.forEach(res=>{
  //         res.file = ''
  //     })
  //   }

  //   getDocument(event:any , order:any , rowIndex : any){
  //       let file = this._utility.onFileChange(event);
  //       console.log(file , order ,rowIndex , this.orderItemList[rowIndex]);
  //       if(file){
  //         let supplierId = JSON.parse(localStorage.getItem('UserObject')).supplierId;    // api call
  //         this._utility.loader(true);
  //         let formData = new FormData();
  //         formData.append('enquiryId' , order.enquiryId)
  //         formData.append('itemId' , order.itemId)
  //         formData.append('supplierId' , supplierId)
  //         formData.append('filePath' , file)
  //         formData.append('documentId' , "1")
  //         if(!this.showToolHealth){
  //             if(order.toolLoanPath){
  //                 // formData.append('')
  //                 this._apiService.putToolLoanAgreementDocument(formData).then((res:any)=>{
  //                     if(res.status){
  //                         console.log(res);
  //                         this._utility.loader(false);
  //                         this._apiService.showMessage(res.message , 'success');
  //                         this.orderItemList[rowIndex].file = null;
  //                         this.getSupplierOrders();
  //                     }
  //                     else{
  //                         this._apiService.showMessage(res.message , 'error')
  //                         this._utility.loader(false);
  //                         this.orderItemList[rowIndex].file = null;
  //                         this.getSupplierOrders();
  //                     }
  //                 })
  //             }

  //             else{
  //                 this._apiService.postToolLoanAgreementDocument(formData).then((res:any)=>{
  //                     if(res.status){
  //                         console.log(res);
  //                         this._utility.loader(false);
  //                         this._apiService.showMessage(res.message , 'success');
  //                         this.orderItemList[rowIndex].file = null;
  //                         this.getSupplierOrders();
  //                     }
  //                     else{
  //                         this._apiService.showMessage(res.message , 'error')
  //                         this._utility.loader(false);
  //                         this.orderItemList[rowIndex].file = null;
  //                         this.getSupplierOrders();
  //                     }
  //                 })
  //             }
  //         }

  //         else{
  //              if(order.toolhealthCheck){
  //                 // formData.append('')
  //                 this._apiService.putToolHealthCheckDocument(formData).then((res:any)=>{
  //                     if(res.status){
  //                         console.log(res);
  //                         this._utility.loader(false);
  //                         this._apiService.showMessage(res.message , 'success');
  //                         this.orderItemList[rowIndex].file = null;
  //                         this.getSupplierOrders();
  //                     }
  //                     else{
  //                         this._apiService.showMessage(res.message , 'error')
  //                         this._utility.loader(false);
  //                         this.orderItemList[rowIndex].file = null;
  //                         this.getSupplierOrders();
  //                     }
  //                 })
  //             }

  //             else{
  //                 this._apiService.postToolHealthCheckDocument(formData).then((res:any)=>{
  //                     if(res.status){
  //                         console.log(res);
  //                         this._utility.loader(false);
  //                         this._apiService.showMessage(res.message , 'success');
  //                         this.orderItemList[rowIndex].file = null;
  //                         this.getSupplierOrders();
  //                     }
  //                     else{
  //                         this._apiService.showMessage(res.message , 'error')
  //                         this._utility.loader(false);
  //                         this.orderItemList[rowIndex].file = null;
  //                         this.getSupplierOrders();
  //                     }
  //                 })
  //             }
  //         }
  //     }
  //   }

  deleteImage(drawing: any) {
    console.log(drawing);

    let formData = new FormData();
    formData.append("toolLoanAgreementId", drawing.id);
    this._apiService.putToolImage(formData).then((res: any) => {
      if (res.success) {
        console.log(res);
        this._apiService.showMessage(res.message, "success");
        this.displayImages = false;
      } else {
        this._apiService.showMessage(res.message, "error");
      }
    });
  }
  getToolListData() {
    this._utility.loader(true)
    this._apiService.getToolList().then((res: any) => {
      if (res.success) {
        this._utility.loader(false)
        if (this.role.roleName === 'Finance') {
          for (let i = 0; i < res.returnValue.length; i++) {
            const currentItem = res.returnValue[i];

            if (currentItem.capital === 'capital') {
              this.financeData.push(currentItem);
            }
          }
          this.ToolListData = this.financeData
        }
        else {
          this.ToolListData = res.returnValue;
          console.log(this.ToolListData, "error");

        }
      } else {
        this.ToolListData = [];
        this._apiService.showMessage(res.message, "error");
        this._utility.loader(false)
      }
    }).catch(err => {
      this.ToolListData = [];
      this._utility.loader(false);
      this._apiService.showMessage("Something went wrong.", "error");
    });
  }
  deleteItem(itemId: any) {
    this._utility.loader(true);
    this._apiService.deleteToolListRecord(itemId).then((res: any) => {
      this._utility.loader(false);
      console.log(res);
      if (res.success == true) {
        this._apiService.showMessage(res.message, "success");
        this.getToolListData();
      } else {
        window.scroll(0, 0);
        this._apiService.showMessage(res.message, "error");
        this.getToolListData();
      }
    });
  }
  confirm1(itemId: any) {
    console.log(itemId);
    this.confirmationService.confirm({
      message: "Are you sure that you want to proceed?",
      header: "Delete Tool List Record",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.msgs = [
          {
            severity: "info",
            summary: "Confirmed",
            detail: "You have accepted",
          },
        ];
        this.deleteItem(itemId);
      },
      reject: () => {
        this.msgs = [
          {
            severity: "info",
            summary: "Rejected",
            detail: "You have rejected",
          },
        ];
      },
    });
  }

  toolListCheckId(checkId: any, supplierName: any, supplierId: any) {
    this.sendToSupplierId = supplierId
    console.log('toolingCustodyId', this.sendToSupplierId)
    const index = this.check1Id.indexOf(checkId);
    if (index === -1) {
      // If checkId is not in the array, push it.
      this.supplierNameArray.push(supplierName);
      this.check1Id.push(checkId);
    } else {
      // If checkId is already in the array, remove it.
      this.supplierNameArray.splice(index, 1);
      this.check1Id.splice(index, 1);
    }
    console.log("supllierName : ", this.supplierNameArray);
    this.check1CommaSeparatedValues = this.check1Id.join(", ");
    console.log(this.check1CommaSeparatedValues);
  }


  sendToolListId() {
    if (this.check1CommaSeparatedValues && this.check1CommaSeparatedValues.trim().length > 0) {
      let formData = new FormData();

      // Split the comma-separated values and get the last value
      const valuesArray = this.check1CommaSeparatedValues.split(",").map(value => value.trim());
      const lastValue = valuesArray[valuesArray.length - 1];

      // Append only the last value to FormData
      formData.append("IsCheckedValues", lastValue);
      formData.append("supplierId", this.sendToSupplierId);

      // Ensure all supplier names are the same
      const allSame = this.supplierNameArray.every(name => name === this.supplierNameArray[0]);

      if (!allSame) {
        this._apiService.showMessage("Not all Supplier Names are the same.", "error");
      } else {
        this._apiService.putToolList(formData).then((res: any) => {
          console.log("API Response:", res);

          if (res.success) {
            this._apiService.showMessage(res.message, "success");
            // Clear all arrays and variables after successful submission
            this.toolListChecked = [];
            this.check1CommaSeparatedValues = '';
            this.supplierNameArray = [];
          } else {
            this._apiService.showMessage(res.message, "error");
          }
        });
      }
    } else {
      this._apiService.showMessage("Please select at least one field.", "error");
    }
  }
  sendtoolforcheckup() {
    if (this.selectedItems && this.selectedItems.length > 0) {
      console.log(this.selectedItems, "error");

      const toolLoanIds = this.selectedItems.map(item => item.toolLoanDetailId);
      const supplierIds = this.selectedItems[0]?.supplierId;
      const supplierNames = this.selectedItems[0]?.supplierName;
      console.log(supplierNames, "data");

      const supplierIdsMatch = this.selectedItems.every(
        item => item.supplierId === supplierIds
      );
      console.log(supplierIdsMatch);


      if (!supplierIdsMatch) {
        this._apiService.showMessage("All selected tools must belong to the same supplier.", "error");
        return;
      }
      const ishealthcheckupdone = this.selectedItems.every(
        item => item.toolhealthGenerated === true
      );
      console.log(ishealthcheckupdone, "cjeckip cjecked");

      if (ishealthcheckupdone) {
        this._apiService.showMessage("Health Checkup Is Already send for supplier", "error");
        return;
      }
      const payload = {
        ToolLoanDetailIds: toolLoanIds.join(','),
        supplierId: supplierIds,
        supplierName: supplierNames
      };
      this._apiService.sendhealthcheckup(payload).then((res: any) => {
        console.log("API Response:", res);

        if (res) {
          this._apiService.showMessage(res.message, "success");
          this.selectedItems = [];
        } else {
          this._apiService.showMessage(res.message, "error");
        }
      });
    } else {
      this._apiService.showMessage("Please select at least one item.", "error");
    }
  }


  navigateToolForm(toolid) {

    localStorage.setItem("toolId", toolid);
    this.route.navigateByUrl('/tool-loan');
  }
  downloadFile() {
    const fileUrl = 'https://api-testing.vendorportalidex.in/FileUpload/BuyerDocument/BuyerDocument.pdf';
    this._apiService.downloadToolDocument(fileUrl);
  }
  uploadDailog() {
    if (this.selectedItems && this.selectedItems.length > 0) {
      const firstpackage = this.selectedItems[0].packageNumber;
      const samepackage = this.selectedItems.every(item => item.packageNumber === firstpackage)
      if (!samepackage) {
        this._apiService.showMessage('All selected items must have the same Package Number', "error");
        return;
      }
      const hasAlreadyUploaded = this.selectedItems.some(item => item.invoiceUploaded === true);

      if (hasAlreadyUploaded) {
        this._apiService.showMessage('Invoice already uploaded for selected items', 'error');
        return;
      }
      const toolIds = this.selectedItems.map(item => item.toolLoanDetailId);
      this.check1CommaSeparatedValues = toolIds.join(',');
      this.display = true
    } else {
      this._apiService.showMessage('Select Atleast one value', "error");
    };
  }
  toolLoanForm = this.fb.group({
    uploadDoc: new FormControl(null, [Validators.required]),
  });
  getFile(event) {
    let file = this._utility.onFileChange(event);
    this.toolLoanForm.controls['uploadDoc'].setValue(file);
  }
  resetform() {
    console.log("data");
    this.toolLoanForm.reset();
    setTimeout(() => {
      if (this.fileInput && this.fileInput.nativeElement) {
        this.fileInput.nativeElement.value = null;
        console.log("File input cleared");
      } else {
        console.warn("fileInput is still null");
      }
    });

  }
  submitForm() {
    console.log(this.toolLoanForm.valid, this.toolLoanForm.value);

    if (this.toolLoanForm.valid) {
      this._utility.loader(true)
      let formData = new FormData();

      formData.append('ToolLoanDetailIds', this.check1CommaSeparatedValues);
      // formData.append('DocumentName', this.toolLoanForm.controls.docName.value);
      // formData.append('DocumentPath', this.toolLoanForm.controls.docPath.value);
      formData.append('invoice', this.toolLoanForm.controls.uploadDoc.value);
      console.log(formData);

      this._apiService.tooldocumentupload(formData).then((res: any) => {
        this._utility.loader(false)
        if (res.success == false) {
          this._apiService.showMessage(res.message, "error");
        } else {
          this._apiService.showMessage(res.message, "success");
          this.fileInput.nativeElement.value = null;
        }
        this.onToggleChange();
        this.check1CommaSeparatedValues = [];
        this.selectedItems = []
      });
      this.display = false
    } else {
      this._apiService.showMessage("Please fill form details", "error");
      console.log("Form not valid");
    }
  }
  // onAprrovPress(toolId, modal, data?: any) {
  //   console.log("Data"); 
  //   console.log("Selected Items:", this.selectedItems);

  //   console.log(toolId,"tool id");
  //   console.log(this.toollistStringId);
  //   this.toollistStringId = toolId
  //   this._utility.loader(true)
  //   this._apiService.getpackagebydetail(toolId).then((res) => {
  //     if (res['success']) {
  //       this.packagedatabyid = res['returnValue']
  //     }
  //     this.approveModalState = true;
  //     this._utility.loader(false)
  //   });
  //   console.log(data, modal, 'toolid: ', this.toollistStringId);
  // }
  onAprrovPress() {
    console.log("Selected Items:", this.selectedItems);
    this.newsupplierid = this.selectedItems[0].supplierId;
    if (!this.selectedItems || this.selectedItems.length === 0) {
      this._apiService.showMessage("Please select at least one item", "error");
      return;
    }
    const approvedtools = this.selectedItems.some(item => item.checker1Status === 'Approved');
    // const reworkby = this.selectedItems.some(item => item.ReworkTo);
    const reworkToChecker1 = this.selectedItems.some(item => item.reworkTo === 'Checker1');
    console.log(reworkToChecker1);

    // if (approvedtools) {
    //   this._apiService.showMessage("Selected items are already approved", "error");
    //   return;
    // }
    if (approvedtools && !reworkToChecker1) {
      this._apiService.showMessage("Selected items are already approved", "error");
      return;
    }
    const itemWithRework = this.selectedItems.find(item => item.reworkTo);
    if (itemWithRework) {
      this.approvalForm.patchValue({
        ApprovedRemark: itemWithRework?.approvedRemark || '-',
        Carno: itemWithRework?.carNumber || '',
      });
      this.existingCarUploadUrl = itemWithRework?.carUploadFilePath || '';
    }
    this.approveModalState = true;
    this._utility.loader(true);

    this.packagedatabyid = this.selectedItems
    this.toollistStringId = this.selectedItems.map(item => item.toolLoanDetailId).join(',');
    console.log(this.toollistStringId, "cehced");

    this._utility.loader(false);
    this.selectedItems = []
  }

  approvalForm = this.fb.group({
    ApprovedRemark: ['', Validators.required],
    isApprove: [''],
    Carno: ['', Validators.required],
    Carupload: [null]
    // document: ['', Validators.required],
  });
  checker2approvalform = this.fb.group({
    checker2remark: ['', Validators.required],
    reworkTo: ['']
  })
  checker3approvalform = this.fb.group({
    checker3remark: ['', Validators.required],
    reworkTo: ['']
  })
  resetApprovalForm() {
    this.approvalForm.reset();
    Object.keys(this.approvalForm.controls).forEach((key) => {
      this.approvalForm.controls[key].setErrors(null);
    });
    this.form.resetForm();
    this.existingCarUploadUrl = ''
  }
  btnClick(string) {
    console.log(string)
    this.statusString = string
  }
  checker2approval(form) {
    console.log('isApprove', this.statusString,)
    console.log(this.toollistStringId, "evert");

    if (this.statusString === 'approve') {
      if (this.checker2approvalform.invalid) {
        this._apiService.showMessage("Please fill all required fields.", "error");
        return;
      }
      this._utility.loader(true)
      let formData = new FormData
      // formData.append('isApproved', 'true');
      formData.append('ApprovedRemarkChecker', this.checker2approvalform.controls.checker2remark.value);
      formData.append('ToolLoanDetailIds', this.toollistStringId)


      this._apiService.checker2toolloanapproved(formData).then((res: any) => {
        this._utility.loader(false);
        if (res.success == false) {
          this._apiService.showMessage(res.message, "error");
        } else {
          this._apiService.showMessage(res.message, "success");
          this.checker2approvalform.reset();
          this.onToggleChange();
          this.Carupload.nativeElement.value = null;
        }
      });
      this.checker2ModalState = false
      this.statusString = ''
    }
    else if (this.statusString === 'reject') {
      const remarkControl = this.checker2approvalform.controls.checker2remark;
      const sendToControl = this.checker2approvalform.controls.reworkTo;
      console.log(remarkControl, "done");

      if (!remarkControl.valid) {
        this._apiService.showMessage("Please fill mandatory details.", "error");
        return;
      }
      if (!sendToControl.valid || !sendToControl.value) {
        this._apiService.showMessage("Please select whom to send rework to.", "error");
        return;
      }

      let formData = new FormData
      // formData.append('isRejected', 'true');
      formData.append('RejectedRemarkChecker', this.checker2approvalform.controls.checker2remark.value);
      formData.append('ReworkTo', this.checker2approvalform.controls.reworkTo.value);
      formData.append('ToolLoanDetailIds', this.toollistStringId)
      this._apiService.checker2toolloanrejected(formData).then((res: any) => {
        if (res.success == false) {
          this._apiService.showMessage(res.message, "error");
        } else {
          this._apiService.showMessage(res.message, "success");
          this.checker2approvalform.reset();
          this.onToggleChange();
          this.checker2ModalState = false;
        }
      });
      this.statusString = ''
    }
  }

  onSubmit(form) {
    console.log('isApprove', this.toollistStringId)
    console.log(this.approvalForm.value);
    console.log(this.approvalForm.controls.Carupload, "invoice");

    if (this.statusString === 'approve') {
      if (this.approvalForm.invalid) {
        this._apiService.showMessage("Please fill all required fields.", "error");
        return;
      }
      this._utility.loader(true)
      let formData = new FormData
      // formData.append('isApproved', 'true');
      formData.append('ApprovedRemark', this.approvalForm.controls.ApprovedRemark.value);
      formData.append('ToolLoanDetailIds', this.toollistStringId)
      formData.append('Carupload', this.approvalForm.controls.Carupload.value)
      formData.append('CarNumber', this.approvalForm.controls.Carno.value)
      const uploadedFiles = this.uploadedFiles;
      console.log(uploadedFiles, 'data');
      if (this.uploadedFiles && this.uploadedFiles.length > 0) {
        this.uploadedFiles.forEach((entry, index) => {
          const uploadForm = new FormData();
          console.log(entry.toolLoanDetailId, 'iddd');
          uploadForm.append('ToolLoanDetailIds', entry.toolLoanDetailId);
          uploadForm.append('invoice', entry.file, entry.file.name);
          this._apiService.tooldocumentupload(uploadForm).then((uploadRes: any) => {
            if (uploadRes.success === false) {
              this._apiService.showMessage(`File ${entry.file.name} failed: ${uploadRes.message}`, "error");
            } else {
              this._apiService.showMessage(`File ${entry.file.name} uploaded: ${uploadRes.message}`, "success");
            }
          });
        });
      }

      this._apiService.checker1toolloanapproved(formData).then((res: any) => {
        this._utility.loader(false);
        if (res.success == false) {
          this._apiService.showMessage(res.message, "error");
        } else {
          this._apiService.showMessage(res.message, "success");
          this.approvalForm.reset();
          this.onToggleChange();
          this.Carupload.nativeElement.value = null;

        }
      });
      this.approveModalState = false
      this.statusString = ''
    }
    else if (this.statusString === 'reject') {
      const remarkControl = this.approvalForm.controls.ApprovedRemark;
      console.log(remarkControl, "done");

      if (!remarkControl.valid) {
        this._apiService.showMessage("Remark is required for rejection.", "error");
        return;
      }
      let formData = new FormData
      // formData.append('isRejected', 'true');
      console.log(this.selectedItems, "supplierId");

      formData.append('RejectedRemark', this.approvalForm.controls.ApprovedRemark.value);
      formData.append('ToolLoanDetailIds', this.toollistStringId),
        formData.append('SupplierId', this.newsupplierid)
      this._apiService.checker1toolloanrejected(formData).then((res: any) => {
        if (res.success == false) {
          this._apiService.showMessage(res.message, "error");
        } else {
          this._apiService.showMessage(res.message, "success");
          this.approveModalState = false;
          this.onToggleChange();
          this.approvalForm.reset();
        }
      });
      this.statusString = ''
    }
  }
  generatetoolloan() {
    const selectedData = this.ToolListData.filter(tool => tool.selected);
    if (selectedData.length > 0) {
      const id = selectedData[0].toolLoanMasterId
      this.ToolListData.forEach(tool => {
        if (!tool.selected) {
          tool.disabled = true;
        }
      });
      this._utility.loader(true);
      this._apiService.getpackagebydetail(id).then((res) => {
        if (res['success']) {
          this.packagedata = res['returnValue']
        }
        this.route.navigate(['/tool-loan-agreement-form'], { state: { packagedata: this.packagedata } })
        this._utility.loader(false);
      })



    }
    else {
      this._apiService.showMessage("please select atleast one checkbox", "error")
    }
  }
  updateCheckboxState() {
    const selectedCount = this.ToolListData.filter(tool => tool.selected).length;
    this.ToolListData.forEach(tool => {
      tool.disabled = selectedCount > 0 && !tool.selected;
    });
  }

  openmodal(id: number) {
    console.log(id);

    this._utility.loader(true)
    this.toolmasterid = id
    this._apiService.getpackagebydetail(id).then((res) => {
      if (res['success']) {
        this.packagedatabyid = res['returnValue']
      }
      this.packagewisedetail = true
      this._utility.loader(false)
    })

  }
  editmodal(id) {
    console.log(id);
    this._utility.loader(true)
    this.toolmasterid = id
    this._apiService.getpackagebydetail(id).then((res) => {
      if (res['success']) {
        this.packagedatabyid = res['returnValue']
        this.route.navigate(['/tool-loan-agreement-form'], { state: { editpackagedata: this.packagedatabyid } })
      }
      this.packagewisedetail = true
      this._utility.loader(false)
    })
  }
  reset(dt2) {
    dt2.reset();
    this.filterval = ''
  }
  reset2(dt3) {
    dt3.reset();
    this.filterval2 = ''
  }
  // console.log(this.form.valid);
  // let formData = new FormData();
  // this.approvalForm.patchValue({
  //   status: 'approve',
  // });
  // if (this.approvalForm.valid) {
  //   let payload: any = {};
  //   // debugger;
  //   if (
  //     this.statusCheck == 'verify' ||
  //     this.statusCheck == 'approve' ||
  //     this.statusCheck == 'draft'
  //   ) {
  //     payload = {
  //       status: this.statusCheck,
  //       remark: this.approvalForm.controls['remark'].value,
  //     };
  //   } else if (
  //     this.statusCheck == 'verificationreject' ||
  //     this.statusCheck == 'reject'
  //   ) {
  //     payload = {
  //       status: this.statusCheck,
  //       reason: this.approvalForm.controls['remark'].value,
  //     };
  //   }
  //   // if (this.verifyString == 'approve') {
  //   //   formData.append('status', this.approvalForm.value.status);
  //   // }
  //   // if (this.verifyString == 'verify') {
  //   //   formData.append('status', 'verify');
  //   // }
  //   // formData.append('remark', this.approvalForm.value.remark);
  //   // this.spinner.show();

  //   // this.ApiService.visaConfirmation(this.selectedId, payload).subscribe(
  //   //   (res) => {
  //   //     this.getVisaData();
  //   //     this.approveModalState = false;
  //   //     form.resetForm();
  //   //     this.approvalForm.reset();
  //   //     this.spinner.hide();
  //   //     this.MessageService.add({
  //   //       severity: 'success',
  //   //       detail: res.message,
  //   //     });
  //   //   }
  //   // );
  // }
  // else if (!this.documentState) {
  //   this.MessageService.add({
  //     severity: 'error',
  //     detail: 'Document Size Should Not Larger Then 10MB!',
  //   });
  // }
  openmodal2(id: number) {
    console.log(id, "ror msg");
    this._utility.loader(true)
    this._apiService.getpackagebydetail(id).then((res => {
      console.log(res, "data");
      this.supplierdata = res['returnValue'];
      console.log(this.supplierdata, "data");
      console.log(this.supplierdata[0].guaranteeDate, "data")
      this._utility.loader(false);
      this.agreementdetail = true;
    }))
  }

  pdfdownload() {
    this._utility.loader(true)
    if (this.dataToExport) {
      this._utility.downloadAsPdf(
        this.dataToExport.nativeElement,
        this.supplierdata[0].supplierName
      );
    }
    this._utility.loader(false)
  }
  onToggleChange() {
    this._utility.loader(true);
    console.log("Toggled:", this.toggleValue);

    if (this.role.checker3 == true && this.role.roleName === 'User') {
      this._apiService.checker3data().then(res => {
        console.log("Asset Wise Data Checker 3", res);
        if (res.success) {
          this.alldata = res['returnValue'] || [];
        } else {
          this.alldata = [];
          this._apiService.showMessage("No tools found", "info");
        }
        this._utility.loader(false);
      }).catch(err => {
        this.alldata = [];
        this._utility.loader(false);
        this._apiService.showMessage("Something went wrong.", "error");
      });
    } else if (this.role.checker2 == true && this.role.roleName === 'Bussiness head') {
      this._apiService.checker2data().then(res => {
        console.log("Asset Wise Data", res);
        if (res.success) {
          this.alldata = res['returnValue'] || [];
        } else {
          this.alldata = [];
          this._apiService.showMessage("No tools found", "info");
        }
        this._utility.loader(false);
      }).catch(err => {
        this.alldata = [];
        this._utility.loader(false);
      });
    } else {
      this._apiService.getallitem().then(res => {
        console.log("Asset Wise Data", res);
        if (res.success) {
          this.alldata = res['returnValue'] || [];
        } else {
          this.alldata = [];
          this._apiService.showMessage("No tools found", "info");
        }
        this._utility.loader(false);
      }).catch(err => {
        this.alldata = [];
        this._utility.loader(false);
      });
    }
  }

  isValidFilePath(path: any): boolean {
    return typeof path === 'string' && path.trim() !== '';
  }
  getFileExtension(path: string): string {
    if (typeof path !== 'string' || !path.trim()) {
      return '';
    }
    // Extract the filename from the path (ignores query parameters)
    const fileName = path?.split('?')[0].split('/').pop();

    return fileName?.split('.').pop()?.toLowerCase() || '';

  }
  getSafeTitle(value: any): string {
    return typeof value === 'string' ? value : '-';
  }
  getSafeFormattedDate(value: any): string {
    if (!value || value === '0001-01-01T00:00:00') return '-';

    const date = new Date(value);
    if (isNaN(date.getTime())) return '-';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  isSelected(item: any): boolean {
    return this.selectedItems.includes(item);
  }

  toggleSelection(item: any) {
    if (this.isSelected(item)) {
      this.selectedItems = this.selectedItems.filter(i => i !== item);
    } else {
      this.selectedItems.push(item);
    }
    console.log(this.selectedItems);

  }

  toggleSelectAll(event: any) {
    const filtered = this.FilteredData2?.filteredValue || this.alldata;
    if (event.target.checked) {
      this.selectedItems = [...filtered]; // or alldata depending on view
    } else {
      this.selectedItems = [];
    }

  }
  // get sortedData() {
  //   if (!this.selectedItems || this.selectedItems.length === 0) return this.alldata;

  //   const selectedIds = this.selectedItems.map(item => item.toolLoanDetailId);
  //    console.log(selectedIds);

  //   const selected = this.alldata.filter(item => selectedIds.includes(item.toolLoanDetailId));
  //   console.log(selected);

  //   const unselected = this.alldata.filter(item => !selectedIds.includes(item.toolLoanDetailId));
  //    log
  //   return [...selected, ...unselected];
  // }
  isAllSelected(): boolean {
    const filtered = this.FilteredData2?.filteredValue || this.alldata;
    return filtered && filtered.length > 0 &&
      filtered.every(item => this.selectedItems.includes(item));
  }
  check() {
    if (this.selectedItems?.length) {
      this.route.navigate(['/tool-health-checkup'], {
        state: { packagedata: this.selectedItems }
      });
    } else {
      this._apiService.showMessage("please select atleast one checkbox", "error")
    }
  }
  checker2process() {
    console.log("called");

    if (!this.selectedItems || this.selectedItems.length === 0) {
      this._apiService.showMessage("Please select at least one item", "error");
      return;
    }
    const allapproved = this.selectedItems.every((item: any) => item.checker1Status == 'Approved');
    if (!allapproved) {
      this._apiService.showMessage("Please ensure all selected items are verified and approved.", "error");
      return
    }
    const alreadyapproved = this.selectedItems.every((item: any) => item.checker2Status == 'Approved');
    if (alreadyapproved) {
      this._apiService.showMessage("Selected Items are already approved", "error");
      return
    }
    console.log(alreadyapproved, 'errr');

    this.checker2ModalState = true

    this.packagedatabyid = this.selectedItems
    this.toollistStringId = this.selectedItems.map(item => item.toolLoanDetailId).join(',');
    console.log(this.toollistStringId, "cehced");
    this._utility.loader(false);
    this.selectedItems = []
  }
  selectedtoolid: any
  async checker2send(asset): Promise<void> {
    console.log(asset, "checker2send");
    this.selectedtoolid = asset.toolLoanDetailId
    this.checker2assign = true
    try {
      const payload = { buMasterId: asset.buMasterId };
      const res = await this._apiService.getMappedchecker2list(payload);
      this._apiService.showMessage(res?.message, "success")
      this.checker2list = res.data;
      this.checker2list = res.data[0]?.checker2List || [];

    } catch (err) {
      console.error('API Error:', err.error?.message);
      this._apiService.showMessage(err.error.message, "error")
    }
  }
  async sendchecker2(): Promise<void> {
    const payload = {
      toolLoanDetailId: this.selectedtoolid,
      checker2Id: this.selectedChecker2Id
    };
    console.log(payload.checker2Id);

    if (payload.checker2Id) {

      try {
        const res = await this._apiService.sendchecker2(payload);
        this._apiService.showMessage(res.message, "success")
        this.checker2assign = false
      } catch (err) {

        this._apiService.showMessage(err, "error")

      }
    }
    else {
      return this._apiService.showMessage('Please Select Checker 2', "error")
    }
  }

  checker3approval(form) {
    if (this.statusString === 'approve') {
      if (this.checker3approvalform.invalid) {
        this._apiService.showMessage("Please fill all required fields.", "error");
        return;
      }
      this._utility.loader(true)
      let formData = new FormData
      formData.append('checker3ApprovedRemark', this.checker3approvalform.controls.checker3remark.value);
      formData.append('ToolLoanDetailIds', this.toollistStringId)
      formData.append('Mode', 'ToolLoanApprovedChecker3')
      formData.append('Checker3Status', '1')

      this._apiService.checker3toolloanapproved(formData).then((res: any) => {
        this._utility.loader(false);
        if (res.success == false) {
          this._apiService.showMessage(res.message, "error");
        } else {
          this._apiService.showMessage(res.message, "success");
          this.checker3approvalform.reset();
          this.onToggleChange();
        }
      });
      this.checker3ModalState = false
      this.statusString = ''
    }
    else if (this.statusString === 'reject') {
      const remarkControl = this.checker3approvalform.controls.checker3remark;
      const sendToControl = this.checker3approvalform.controls.reworkTo;

      if (!remarkControl.valid) {
        this._apiService.showMessage("Please fill mandatory details.", "error");
        return;
      }
      // if (!sendToControl.valid || !sendToControl.value) {
      //   this._apiService.showMessage("Please select whom to send rework to.", "error");
      //   return;
      // }

      let formData = new FormData
      formData.append('Checker3RejectRemark', this.checker3approvalform.controls.checker3remark.value);
      formData.append('ReworkTo', this.checker3approvalform.controls.reworkTo.value);
      formData.append('ToolLoanDetailIds', this.toollistStringId)
      formData.append('Mode', 'ToolLoanRejectedChecker3')
      formData.append('Checker3Status', '2')
      this._utility.loader(true);
      this._apiService.checker3toolloanapproved(formData).then((res: any) => {
        this._utility.loader(false);
        if (res.success == false) {
          this._apiService.showMessage(res.message, "error");
        } else {
          this._apiService.showMessage(res.message, "success");
          this.checker3approvalform.reset();
          this.onToggleChange();
          this.checker3ModalState = false;
        }
      });
      this.statusString = ''
    }
  }

  checker3process() {
    if (!this.selectedItems || this.selectedItems.length === 0) {
      this._apiService.showMessage("Please select at least one item", "error");
      return;
    }
    const allapproved = this.selectedItems.every((item: any) => item.checker2Status == 'Approved');
    if (!allapproved) {
      this._apiService.showMessage("Please ensure all selected items are verified and approved by Checker 2.", "error");
      return
    }
    const alreadyapproved = this.selectedItems.every((item: any) => item.checker3Status == 'Approved');
    if (alreadyapproved) {
      this._apiService.showMessage("Selected Items are already approved", "error");
      return
    }

    this.checker3ModalState = true

    this.packagedatabyid = this.selectedItems
    this.toollistStringId = this.selectedItems.map(item => item.toolLoanDetailId).join(',');
    this._utility.loader(false);
    this.selectedItems = []
  }

  async checker3send(asset): Promise<void> {
    this.selectedtoolid = asset.toolLoanDetailId
    this.checker3assign = true
    try {
      const payload = { buMasterId: asset.buMasterId };
      const res = await this._apiService.getMappedchecker3list(payload);
      this._apiService.showMessage(res?.message, "success")
      this.checker3list = res.data;
      this.checker3list = res.data[0]?.checker3List || [];
    } catch (err) {
      console.error('API Error:', err.error?.message);
      this._apiService.showMessage(err.error.message, "error")
    }
  }

  async sendchecker3(): Promise<void> {
    const payload = {
      toolLoanDetailId: this.selectedtoolid,
      checker3Id: this.selectedChecker3Id
    };

    if (payload.checker3Id) {
      try {
        const res = await this._apiService.sendchecker3(payload);
        this._apiService.showMessage(res.message, "success")
        this.checker3assign = false
      } catch (err) {
        this._apiService.showMessage(err, "error")
      }
    }
    else {
      return this._apiService.showMessage('Please Select Checker 3', "error")
    }
  }

}


// deleteImage(drawing:any){
//     console.log(drawing);

//     let formData = new FormData();
//     formData.append('toolLoanAgreementId' , drawing.id)
//     this._apiService.putToolImage(formData).then((res:any)=>{
//         if(res.success){
//             console.log(res);
//             this._apiService.showMessage(res.message , 'success');
//             this.displayImages = false;
//         }

//         else{
//             this._apiService.showMessage(res.message , 'error');
//         }
//     })
// }

